import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import "@fontsource/montserrat";
import MsgIcon from "../../../../../assets/svg/dashboard/Icon_Message_White.svg";
import LineWithDot from "../../../../../assets/svg/dashboard/Line wit Dot.svg";
import MessagesTable from "./MessagesTable";
import machines from "./rightbottom.svg";

// : "#838186"

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "500px",
    paddingTop: "30px",
    paddingBottom: "150px",
    backgroundColor: "#f0f3f5",
    position: "relative",
  },
  headingOne: {
    fontSize: "28px",
    fontWeight: 600,
    fontFamily: "Montserrat",
    color: "rgba(62, 74, 89, 1)",
  },
  headingTwo: {
    color: "rgba(86, 58, 150, 1)",
    fontSize: "40px",
    fontWeight: "600",
    fontFamily: "Montserrat",
  },
  upperDisplay: {
    width: "80%",
    marginTop: "25px",
    padding: "25px",
    background:
      "linear-gradient(90deg, rgba(222, 212, 245,0.8130602582830007) 0%, rgba(247,243,255,1) 100%)",
  },
  messageIconWrapper: {
    height: "130px",
    width: "200px",
    backgroundColor: "#816aaf",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "18px",
  },
  newMessageButtonWrapper: {
    display: "flex !important",
    justifyContent: "flex-end !important",
  },
  machines: {
    position: "absolute",
    height: "400px",
    bottom: 40,
    right: 20,
  },
}));

const UpperDisplaySurface = () => {
  const classes = useStyles();

  return (
    <Box style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <Paper elevation={3} className={classes.upperDisplay}>
        <Grid container>
          <Grid item xs={3}>
            <Box className={classes.messageIconWrapper}>
              <img
                src={MsgIcon}
                style={{ height: "90px", width: "80px" }}
                alt="messages icon"
              />
            </Box>
          </Grid>
          <Grid item xs={5}>
            <Box
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <p
                style={{
                  color: "#3AC2D7",
                  textAlign: "left",
                  fontWeight: "bold",
                  fontSize: "26px",
                }}
              >
                MESSAGES: 03
              </p>
              <img
                src={LineWithDot}
                style={{
                  maxWidth: "none",
                  maxHeight: "none",
                  width: "230px",
                  height: "10px",
                  marginLeft: 0,
                }}
                alt="line with dot"
              />
              <p
                style={{
                  color: "#816aaf",
                  fontWeight: "bold",
                  textAlign: "left",
                }}
              >
                UNREAD: 1
              </p>
            </Box>
          </Grid>
          <Grid item xs={4} className={classes.newMessageButtonWrapper}>
            <div
              className="dashboard-purple-btn top-btn"
              style={{
                marginTop: "10px",
              }}
            >
              <span
                className="blue-link-dashboard"
                style={{
                  paddingRight: "0px",
                  cursor: "pointer",
                  fontWeight: "600",
                  fontSize: "18px",
                }}
              >
                SEND NEW MESSAGE
              </span>
            </div>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

// const MessagesTable = () => {
//   return <Box>messages table</Box>;
// };

const MentorSessions = (props) => {
  const classes = useStyles(0);

  return (
    <Box className={classes.root}>
      <img src={machines} alt="machines" className={classes.machines} />
      <Typography className={classes.headingOne}>
        MAARG Portal by Startup India
      </Typography>
      <Typography className={classes.headingTwo}>MY SESSIONS</Typography>
      <UpperDisplaySurface />
      <MessagesTable />
    </Box>
  );
};

export default MentorSessions;
